<script setup lang="ts">
  defineProps({
    type: {
      type: String,
      default() {
        return 'primary'
      }
    }
  })
</script>

<template>
  <div class="flex justify-center items-center">
    <div class="w-[6px] h-[6px] rounded-full mr-2" :class="[type]"></div>
    <slot></slot>
  </div>
</template>

<style scoped>
  .primary {
    background-color: var(--el-color-primary-dark-2);
  }
  .success {
    background-color: var(--el-color-success-dark-2);;
  }
  .warning {
    background-color: var(--el-color-warning-dark-2);
  }
  .danger {
    background-color: var(--el-color-danger-dark-2);
  }
  .info {
    background-color: var(--el-color-info-dark-2);
  }
</style>